import AloDrawer from 'components/Drawer/AloDrawer'
import { useLocation, useNavigate } from 'react-router-dom'
import { Fragment } from 'react/jsx-runtime'
import { useModalStore } from 'state/useModalStore'
import { twMerge } from 'tailwind-merge'
import { useTranslation } from 'translations'
import { PRIVATE_MENU_CONFIGS } from './config'

const PrivateFooter = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const modalBalance = useModalStore((s) => s.modalBalance)
  const setModalBalance = useModalStore((s) => s.setModalBalance)

  const toggleBalance = () => setModalBalance({ open: !modalBalance.open })

  return (
    <Fragment>
      <div className='grid grid-cols-5 gap-3 py-3 border-solid border-t-[1px] border-[#ccc] container bg-white fixed bottom-0 z-10 left-0 right-0'>
        {PRIVATE_MENU_CONFIGS.map((menu) => {
          const active = menu.actives.includes(pathname)
          const Icon = menu.icon
          const isRotate = menu.label === 'Send'
          const isAlo = menu.label === 'ALO'

          return (
            <div
              key={menu.label}
              className='flex flex-col items-center gap-2'
              onClick={() => (isAlo ? toggleBalance() : navigate(menu.href as string))}
            >
              <Icon className={twMerge('text-lg', isRotate ? '-rotate-90' : '', active ? 'text-primary' : '')} />
              <p className={twMerge('text-center text-xs', active ? 'text-primary font-bold' : '')}>{t(menu.label)}</p>
            </div>
          )
        })}
      </div>
      <AloDrawer open={modalBalance.open} onClose={toggleBalance} />
    </Fragment>
  )
}

export default PrivateFooter
